import { Title } from '@radix-ui/react-dialog'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

export type TitleProps = ComponentPropsWithoutRef<typeof Title>

export interface DialogTitleProps extends TitleProps {
  children?: TitleProps['children']
  asChild?: TitleProps['asChild']
  className?: TitleProps['className']
}

export const DialogTitle = forwardRef<
  ElementRef<typeof Title>,
  DialogTitleProps
>(({ className, ...delegated }, ref) => (
  <Title
    ref={ref}
    className={cn(
      'font-semibold text-lg leading-none tracking-tight',
      className
    )}
    {...delegated}
  />
))
DialogTitle.displayName = Title.displayName
